import React from 'react';
import * as R from 'unitx/ramda';
// export const ComponentTypes: Record<keyof Mapping, keyof Mapping> = {
//   button: 'button',
//   toggle: 'toggle',
//   title: 'title',
//   description: 'description',
//   text: 'text',
//   input: 'input',
//   select: 'select',
//   fieldContainer: 'fieldContainer',
//   errorText: 'errorText',
//   errorTitle: 'errorTitle',
//   datepicker: 'datepicker',
//   slider: 'slider',
//   checkbox: 'checkbox',
// }
export const defaultProps = {
  requiredTitle: '*',
  arrayAddTitle: 'Add',
  titleEnabled: true,
  descriptionEnabled: true,
  showErrorList: false,
  mapping: {
    button: {
      style: {},
      mode: 'outline'
    },
    toggle: {
      style: {},
      mode: 'outline'
    },
    title: {
      style: {},
      category: 's1'
    },
    objectTitle: {
      style: {},
      category: 'h6'
    },
    arrayTitle: {
      style: {},
      category: 'h6'
    },
    description: {
      style: {},
      category: 's1'
    },
    objectDescription: {
      style: {},
      category: 's1'
    },
    arrayDescription: {
      style: {},
      category: 's1'
    },
    label: {
      style: {},
      category: 's1'
    },
    text: {
      style: {},
      category: 'p1'
    },
    input: {
      style: {},
      category: 'p1'
    },
    select: {
      style: {} // size: 'medium',

    },
    fieldContainer: {
      style: {
        marginBottom: 5
      },
      disabled: true
    },
    propertiesContainer: {
      style: {
        paddingLeft: 10
      }
    },
    errorText: {
      style: {
        textAlignVertical: 'center'
      },
      status: 'danger',
      category: 'c2'
    },
    errorTitle: {
      style: {},
      status: 'danger',
      category: 'h6'
    },
    datepicker: {
      style: {}
    },
    slider: {
      style: {},
      mode: 'outline'
    },
    checkbox: {
      style: {} // mode: 'outline',

    },
    downIcon: {
      name: 'chevron-down'
    },
    upIcon: {
      name: 'chevron-up'
    },
    addIcon: {
      name: 'plus'
    },
    deleteIcon: {
      name: 'minus'
    }
  }
};
const FormContext = /*#__PURE__*/React.createContext(defaultProps);
export const useFormContext = (override = {}) => {
  const defaultValue = React.useContext(FormContext);
  return R.mergeDeepRight(defaultValue, override);
};
export default FormContext;